import React from 'react';
import classnames from 'classnames';

class Form extends React.Component
{
  constructor(props)
  {
    super(props);

    this.state = {
      isValidated: false
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }

  validate()
  {
    let form = this.refs.form;
    let formValid = form.checkValidity() || false;

    for (let i = 0; i < form.length; i++)
    {
      let element = form[i];

      if (element.nodeName.toLowerCase() !== 'button')
      {
        if (!formValid && !element.validity.valid)
        {
          let errorNode = element.parentNode.querySelector('.utv-invalid-feedback');

          if (errorNode)
            errorNode.remove();

          errorNode = document.createElement('span');
          errorNode.textContent = element.validationMessage;
          errorNode.className = this.props.errorclass;
          element.parentNode.insertBefore(errorNode, element.nextSibling);
        }
        else
        {
          let errorNode = element.parentNode.querySelector('.utv-invalid-feedback');

          if (errorNode)
            errorNode.remove();
        }
      }
    }

    return formValid;
  }

  onSubmit(event)
  {
    event.preventDefault();

    if (this.validate() && this.props.submit)
      this.props.submit();

    this.setState({isValidated: true});
  }

  render()
  {
    let classNames = classnames(
      this.props.classes,
      {'was-validated': this.state.isValidated}
    );

    return (
      <form
        ref="form"
        onSubmit={this.onSubmit}
        className={classNames}
        noValidate
      >
        {this.props.children}
      </form>
    );
  }
}

export default Form;
